module.exports = __webpack_public_path__ + "static/media/shift-page-hero-mookata.b720f231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shift-page-hero-mookata.jpg
// module id = 121
// module chunks = 0